const SYNONYMS = [
  ['lg', 'large'],
  ['sm', 'small'],
  ['rec', 'rectangle'],
  ['sq', 'square'],
];

/** Lowercase, treat non-alphanumeric as spaces, collapse whitespace. */
function normalize(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

function tokenVariants(token) {
  const normalizedToken = normalize(token);
  const group = SYNONYMS.find((items) => items.includes(normalizedToken));
  return group || [normalizedToken];
}

function productHaystack(product) {
  return [product.PARTNUM, product.OLDPARTNUM, product.DESCRIPTION, product.COLOR].map(normalize);
}

function tokenMatchesProduct(product, token) {
  const variants = tokenVariants(token);
  const fields = productHaystack(product);
  return variants.some((variant) => fields.some((field) => field.includes(variant)));
}

/** Lowest index of any synonym variant across product fields (Infinity if none). */
function earliestTokenPosition(product, token) {
  const variants = tokenVariants(token);
  const fields = productHaystack(product);
  let best = Infinity;
  for (const variant of variants) {
    for (const field of fields) {
      const index = field.indexOf(variant);
      if (index !== -1 && index < best) best = index;
    }
  }
  return best;
}

function compareSearchResults(a, b, tokens) {
  // Prefer products where the first search token appears earlier (esp. at the start).
  const posA = earliestTokenPosition(a, tokens[0]);
  const posB = earliestTokenPosition(b, tokens[0]);
  if (posA !== posB) return posA - posB;

  const descA = normalize(a.DESCRIPTION);
  const descB = normalize(b.DESCRIPTION);
  return descA.localeCompare(descB) || normalize(a.PARTNUM).localeCompare(normalize(b.PARTNUM));
}

export function searchQuoteProducts(products = [], query = '', limit = 20) {
  const tokens = normalize(query).split(' ').filter(Boolean);

  if (!tokens.length) return products.slice(0, limit);

  return products
    .filter((product) => tokens.every((token) => tokenMatchesProduct(product, token)))
    .sort((a, b) => compareSearchResults(a, b, tokens))
    .slice(0, limit);
}
